import React from 'react';
import {
  MdOutlineAssignmentTurnedIn, 
  MdOutlineAssignmentLate,
} from 'react-icons/md';
import { StatusConfig, TableColumn, EvaluationStatus } from './types';
import { EvaluationType, ImpactEvaluationStatus } from 'types/evaluation';

export const IMPACT_STATUS_MAP: Record<EvaluationStatus, StatusConfig> = {
  [ImpactEvaluationStatus.PENDING]: {
    label: 'Pendente',
    badgeColor: '#CA7D4F',
    fontColor: '#CA7D4F',
    tooltip: 'Avaliação de impacto pendente',
    icon: React.createElement(MdOutlineAssignmentLate),
  },
  [ImpactEvaluationStatus.FINISHED]: {
    label: 'Concluído',
    badgeColor: '#5DB15D',
    fontColor: '#5DB15D',
    tooltip: 'Avaliação de impacto respondida',
    icon: React.createElement(MdOutlineAssignmentTurnedIn),
  },
  [ImpactEvaluationStatus.EXPIRED]: {
    label: 'Expirada',
    badgeColor: '#ED4141',
    fontColor: '#ED4141',
    tooltip: 'Avaliação de impacto expirada',
    icon: React.createElement(MdOutlineAssignmentLate),
  },
};

export const TABLE_COLUMNS: TableColumn[] = [
  { header: 'Nome do treinamento', accessor: 'title' },
  { header: 'Disponibilizado em', accessor: 'availableAt' },
  { header: 'Expira em', accessor: 'expiresAt' },
  { header: 'Status', accessor: 'status' },
];

export const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

export const EVALUATION_TYPE = EvaluationType.STUDENT_IMPACT;
